window.Products.HomeDecor.DuvetCoverQueen = function() {};
window.Products.HomeDecor.DuvetCoverQueen.inherits(window.Products.HomeDecor.DuvetCover);
window.Products.HomeDecor.DuvetCoverQueen.has_3d = true;
window.Products.HomeDecor.DuvetCoverQueen.id = '86-queen';
window.Products.HomeDecor.DuvetCoverQueen.saveId = 86;
window.Products.HomeDecor.DuvetCoverQueen.slug = 'duvet-cover-queen';
window.Products.HomeDecor.DuvetCoverQueen.dpi = 150;
window.Products.HomeDecor.DuvetCoverQueen.prototype.designObject = 1;